/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `podklad_pro_fakturu` - podklad_pro_fakturu
 *   * `protokol_vydej_dat` - protokol_vydej_dat
 *   * `danovy_doklad` - danovy_doklad
 * ```
 */
export const DocTypeEnum = {
  podklad_pro_fakturu: 'podklad_pro_fakturu',
  protokol_vydej_dat: 'protokol_vydej_dat',
  danovy_doklad: 'danovy_doklad',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DocTypeEnum = ValuesOf<typeof DocTypeEnum>;

export type DocTypeEnumRequest = DocTypeEnum;
export type DocTypeEnumResponse = DocTypeEnum;
